module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal"
  }, [(!_vm.isReadOnly) ? _c('div', {
    staticClass: "d-guides"
  }, [_c('h4', [_vm._v("Vejledning")]), _vm._v(" "), _vm._m(0), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('GrundskoleIndberetningTimetalFag', {
    staticClass: "marg-1-top",
    attrs: {
      "undervisningskema": _vm.undervisningskema,
      "fagFraStil": _vm.fagFraStil,
      "isReadOnly": _vm.isReadOnly
    },
    on: {
      "update": _vm.updateSubject,
      "updateKonfirmation": _vm.updateKonfirmation,
      "updatePraktik": _vm.updatePraktik,
      "setTolaerer": _vm.setTolaerer,
      "setForanstaltning": _vm.setForanstaltning,
      "nulstilKlasse": _vm.nulstilKlasse
    }
  }), _vm._v(" "), _c('GrundskoleIndberetningTimetalFagSpecial', {
    staticClass: "marg-1-top",
    attrs: {
      "undervisningskema": _vm.undervisningskema,
      "isReadOnly": _vm.isReadOnly
    },
    on: {
      "update": _vm.updateSubject,
      "updateKonfirmation": _vm.updateKonfirmation,
      "updatePraktik": _vm.updatePraktik,
      "setTolaerer": _vm.setTolaerer,
      "setForanstaltning": _vm.setForanstaltning
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "italic"
  }, [_vm._v("\n      I dette skema skal der indtastes oplysninger om de årlige undervisningstimer, som skolen planlægger at give\n      eleverne i de enkelte fag på hver årgang. Bemærk, at timetallene skal opgøres som undervisningstimer á 60\n      minutter.\n      Der er automatisk importeret timetal fra UVM, som I har mulighed for at tilpasse. Hvis I ikke ønsker at bruge\n      disse tal – eller ikke ønsker at indberette for en årgang – kan I blot klikke på \"Nulstil\".\n      "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "text-link",
    attrs: {
      "target": "_blank",
      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2024/1012/Praktisk%20vejledning_Antal%20elever%20og%20undervisningstimer_folkeskoler_2024.pdf"
    }
  }, [_vm._v("\n        Læs den officielle vejledning fra STIL her\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Vær særlig opmærksom på:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("1) Tysk og Fransk skal udfyldes, da de står med 0."), _c('br'), _vm._v("2) Vælg hvilken årgang konfirmationsforberedelse finder\n        sted.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-251e5067!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningTimetal.vue
// module id = 1809
// module chunks = 1